import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.REACT_APP_API_URI;

export const socket = io(URL, { transports : ['websocket', 'polling', 'flashsocket'] });
